<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="copyright-page">
<p class="copyt">Publisher: Amy Barrett-Daffin</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Senior Editor: Roxane Cerda</p>
<p class="copy">Editor: Madison Moore</p>
<p class="copy">Technical Editor: Debbie Rodgers</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Tim Manibusan</p>
<p class="copy">Illustrator: Aliza Shalit</p>
<p class="copy">Photography Coordinator: Lauren Herberg</p>
<p class="copy">Production Assistant: Rachel Ackley</p>
<p class="copy">Photography by Stacy Grant</p>
<p class="copy">Pattern provided by MOJX <a href="http://studio/shutterstock.com" target="_blank">Studio/Shutterstock.com</a></p>
<p class="copyt">Published by Stash Books, an imprint of C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
<p class="image"><img alt="" src="images/pg3_1.jpg"/></p>
<p class="image"><img alt="" src="images/pg3_2.jpg"/></p>
<p class="image"><img alt="" src="images/pg3_3.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copyright.vue?374e934e